// Financial Freedom Calculator -- the conversion hook.
//
// Wraps the dynamic, backend-generated hook string in a premium dark-themed CTA
// banner that visually contrasts the light calculator surface and points the
// visitor at the Forge Ultra membership funnel (same destination the sibling
// ETF Wealth Builder's ConversionCTA uses).

import React from 'react';

interface ForgeUltraHookProps {
    hookText: string;
}

export const ForgeUltraHook: React.FC<ForgeUltraHookProps> = ({ hookText }) => {
    return (
        <div className="mt-8 bg-slate-900 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6 shadow-xl relative overflow-hidden border border-slate-800">
            {/* Background decorative glow. */}
            <div className="absolute top-0 right-0 -mt-10 -mr-10 w-48 h-48 bg-emerald-600 rounded-full opacity-20 blur-3xl pointer-events-none"></div>

            <div className="flex-1 relative z-10 text-center md:text-left">
                <div className="inline-block px-3 py-1 bg-emerald-900/50 border border-emerald-700 rounded-full text-emerald-300 text-xs font-bold tracking-widest uppercase mb-3">
                    Unique Forge Ultra Wealth-Building Platform
                </div>
                <h3 className="text-xl md:text-2xl font-extrabold text-white mb-2 tracking-tight">
                    Unlock Our Premium Insights
                </h3>
                <p className="text-sm md:text-base text-slate-300 leading-relaxed max-w-2xl font-medium">
                    {hookText}
                </p>
            </div>

            <div className="shrink-0 w-full md:w-auto relative z-10">
                <a
                    href="https://www.ki-wealth.com/membership-levels"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex w-full md:w-auto items-center justify-center px-8 py-4 bg-emerald-600 hover:bg-emerald-500 text-white font-bold rounded-xl transition-all shadow-[0_0_20px_rgba(5,150,105,0.4)] hover:shadow-[0_0_25px_rgba(5,150,105,0.6)] active:scale-95"
                >
                    Explore Forge Ultra
                </a>
            </div>
        </div>
    );
};
